import React from 'react';
import { isPast } from 'helpers/dates';
import { StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import Panel from 'components/general/panel';
import FocusTile from 'views/user/1-2-1s/components/performanceDashboard/components/focusTile';

export const Objectives = ({ focus, data, setShow }) => {
    if (!data || data.length === 0) return null;

    const st = (path, ...rest) => SystemText(`Home/Widgets/WhatsHappening/Objectives/${path}`, ...rest);

    const total = data.length;
    const overdue = data.filter(s => isPast(s.due)).length;
    const colour = overdue > 0 ? 'danger' : 'warning';

    const slug = `Outstanding${overdue > 0 ? 'Overdue' : ''}${
        overdue === 1 && total === 1 ? 'Only' : overdue === 1 ? 'One' : overdue === total ? 'All' : 'Some'
    }`;

    const message = st(slug, total, overdue);

    const url = total === 1 ? `/objectives/${data[0].profile_Id}/objective/${data[0].id}` : '';

    const date = total === 1 ? data[0].due : null;

    const buttonText = total === 1 ? (data[0].comments ? 'Continue' : 'Start') : undefined;

    if (focus)
        return (
            <FocusTile
                tileType="objective"
                colour={overdue > 0 ? 'red' : 'green'}
                icon="fa-calendar"
                message={message}
                url={url}
                setShow={setShow}
                date={date}
                buttonText={buttonText}
            />
        );

    return <Panel colour={colour} icon="exclamation-triangle" message={message} url={url} setShow={setShow} />;
};

export default Objectives;
